module.exports = __webpack_public_path__ + "static/media/bg-image-57.ee554567.jpg";